let modal;
var toggleMenu = document.querySelector(".mobile-menu");
var burgerIcon = document.querySelector(".burger-icon");
var closeIcon = document.querySelector(".close-icon");
var isActive = toggleMenu.classList.contains("show");

document.addEventListener("click", (e) => {
  if (e.target.className === "modal-open") {
    modal = document.getElementById(e.target.dataset.id);
    toggleMenu.classList.remove('show');
    burgerIcon.classList.remove('d-none');
    closeIcon.classList.add('d-none');
    openModal(modal);
  }
});

const openModal = (modal) => {
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  modal.setAttribute("open", "true");
  document.addEventListener("keydown", escClose);
  let overlay = document.createElement("div");
  overlay.id = "modal-overlay";
  document.body.appendChild(overlay);
};

const escClose = (e) => {
  if (e.keyCode == 27) {
    closeModal();
  }
};

//Close menu if register modal is open
jQuery(document).ready(function($) {
  $(document).on("click",".sign-up-with-email",function() {
      let registerModal = jQuery(".login-register-modal");
      
      if(registerModal.hasClass('show-register')){
        $('#demo-modal').removeAttr('open');
        $(toggleMenu).removeClass('show');
        $(burgerIcon).removeClass('d-none');
        $(closeIcon).addClass('d-none');
      }    
  });

  $(document).on("click",".modal-close",function() {
    
      $('#modal-overlay').remove();
      $('body').css('overflow' , 'scroll');
      $('body').css('position' , 'relative');
      $('#demo-modal').removeAttr('open');
  });

  $(document).on("click",".icon-close",function() {

    $('#demo-modal').removeAttr('open');
    $('#modal-overlay').remove();
    $('body').css('overflow' , 'scroll');
    $('body').css('position' , 'relative');

  });

  $(document).on("click",".login",function() {

    let loginModal = jQuery(".login-register-modal");
    if(loginModal){
      $('body').css('overflow' , 'hidden');
      $('body').css('position' , 'fixed');
    }else{
      $('body').css('position' , 'relative');
    } 
  });

});
